import React from "react"
import { Parallax } from "react-spring/renderprops-addons.cjs"
import Layout from "@lekoarts/gatsby-theme-cara/src/components/layout"
import Hero from "@lekoarts/gatsby-theme-cara/src/components/hero"
import Cards from "../components/cards"
import About from "@lekoarts/gatsby-theme-cara/src/components/about"
import Contact from "@lekoarts/gatsby-theme-cara/src/components/contact"

const Cara = () => (
  <Layout>
    <div>
      <Hero />
      <About />
      <Cards cardType={`Projects`} />
      <Cards cardType={`Press`} />
      <Cards cardType={`Research & Patents`} />
      <Cards cardType={`Bartending`} />
      <Contact />
    </div>
  </Layout>
)

export default Cara
